import { SubmenuType } from '@/config/navigationPages';

const isPathActive = (itemPath: string, locationPathname: string): boolean =>
  locationPathname === itemPath || locationPathname.startsWith(itemPath + '/');

export const checkSubMenuActive = (
  subMenu: SubmenuType[],
  locationPathname: string,
): boolean => {
  return subMenu.some((item) => {
    if (isPathActive(item.path, locationPathname)) return true;

    if (item.subMenu) {
      const nestedSubMenu = Object.values(item.subMenu);
      return checkSubMenuActive(nestedSubMenu, locationPathname);
    }

    return false;
  });
};

export const checkItemActive = (
  item: SubmenuType,
  locationPathname: string,
): boolean => {
  if (isPathActive(item.path, locationPathname)) return true;

  if (item.subMenu) {
    const nestedSubMenu = Object.values(item.subMenu);
    return checkSubMenuActive(nestedSubMenu, locationPathname);
  }

  return false;
};
